import React, { useState, useEffect } from 'react';
import styles from './checkSubject.module.scss';
import { ApiCore } from '../../api/index';
import { createFromIconfontCN } from '@ant-design/icons';
import defaultAvatar from '../../static/icon/defaultAvatar.svg';
import { ActivityIndicator, Button, DatePickerView, InputItem, List, Modal, Picker, Radio, Toast } from 'antd-mobile';
import close from '../../static/icon/close.svg';
// import backBtn from '../../static/icon/backBtn.svg';
import backBtn from '../../static/icon/back_button.png';
import utils from '../../utils/utils';
import VisitForm from '../visitForm/visitForm'; 
import SubjectBind from '../subjectBind/subjectBind'
import SignAgreementLink from './components/signAgreementLink';
const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_dm1ywqphtbf.js',
});

function CheckSubject(props: any) {
    let _projectType = utils.getUrlParams().projectType;

    let token = sessionStorage.getItem('token');
    // let projectRoleCode = sessionStorage.getItem('projectRoleCode');
    let mToken: any = {};
    if (token) {
        try {
            mToken = JSON.parse(token);
        } catch (error) {
            mToken = {};
        }
    }

    //选择的项目
    const [projectType, setProjectType] = useState<any>(_projectType || '');
    //受试者数据
    const [subjectsData, setSubjectsData] = useState<any>([]);
    //表单数据
    const [formData, setFormData] = useState<any>([]);
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //实际访视日期
    const [visitDate, setVisitDate] = useState<any>();
    //实际访视日期选择弹框是否显示
    const [visitDateModalShow, setVisitDateModalShow] = useState<boolean>(false);
    //备注弹框是否显示
    const [remarkModalShow, setRemarkModalShow] = useState(false);
    //备注类型list
    const [remarkTypeList, setRemarkTypeList] = useState<any>([]);
    //当前选中的备注类型
    const [currentRemarkType, setCurrentRemarkType] = useState<any>();
    //备注内容
    const [remarkValue, setRemarkValue] = useState<any>();
    //备注警示类型列表
    const [isWarningList, setIsWarningList] = useState<any>([]);
    //备注是否为警示
    const [remarkIsWarning, setRemarkIsWarning] = useState<any>();
    //显示表单（当前只有一个节点时）
    const [showVisitForm, setShowVisitForm] = useState<Boolean>(false);

    const [projectRoleCode, setProjectRoleCode] = useState('')

    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;

    useEffect(() => {
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');
        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }
    }, [])
    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;

            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }

    useEffect(() => {
        //设置网页title
        document.title = '入组筛查';
        getData();
    }, [])

    //获取数据
    const getData = () => {
        setLoading(true);
        api.getSubjectdDetail({ id: props.match.params.id }).then(res => {
            if (res.code == '0') {

                if (!res.data) {
                    return
                }
                sessionStorage.setItem('caseCode', res.data.code)
                sessionStorage.setItem('projectRoleCode', res.data.roleCode)
                sessionStorage.setItem('eventCode', res.data.visits[0].id)
                // 缓存一个编辑状态，提交后可加载更多
                sessionStorage.setItem('editModel', res.data.editModel)
                setProjectRoleCode(res.data.roleCode)
                setSubjectsData(res.data);
                setShowVisitForm(false); // 每次切换，重置表单渲染
                api.getFormsById({ id: res.data.visits[0].id }).then(res => {
                    if (res.code == '0') {
                        let filterArr = [];
                        filterArr.push(res.data);
                        setFormData(filterArr);
                        // 如果节点下面只有一个表单时，直接渲染
                        let _item = res.data;
                        // if (_item && _item.forms && _item.forms.length === 1) {
                        if (_item && _item.forms && _item.type === 'SingleForm') {
                            clickForm(_item, _item.forms[0])();
                        }
                    }
                })
            }
            setLoading(false);
        })
    }

    //switch表单左侧的border颜色
    const switchFormBorder = (formData: any) => {
        switch (formData.inputState) {
            case 'Complete':
                return <div style={{ backgroundColor: '#6c96f7' }}></div>
            case 'Running':
                return <div style={{ backgroundColor: '#5ebcbc' }}></div>
            case 'Wait':
                return <div style={{ backgroundColor: '#e6ebf5' }}></div>
            case 'Question':
                return <div style={{ backgroundColor: '#ef8767' }}></div>
            case 'Answer':
                return <div style={{ backgroundColor: '#477291' }}></div>
            default:
                break;
        }
    }

    //处理from中input状态
    const switchFormInputState = (inputState: any) => {
        switch (inputState) {
            case 'Complete':
                return <IconFont type="iconInput_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconInput_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconInput_Wait"></IconFont>
            default:
                break;
        }
    }

    //处理from中check状态
    const switchFormCheckState = (checkState: any) => {
        switch (checkState) {
            case 'Complete':
                return <IconFont type="iconCheck_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconCheck_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconCheck_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconCheck_Question"></IconFont>
            default:
                break;
        }
    }

    //处理from中question状态
    const switchFormQuestionState = (questionState: any) => {
        switch (questionState) {
            case 'Complete':
                return <IconFont type="iconQuestion_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconQuestion_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconQuestion_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconQuestion_Question"></IconFont>
            case 'Answer':
                return <IconFont type="iconQuestion_Answer"></IconFont>
            default:
                break;
        }
    }

    //处理from中Examine状态
    const switchFormExamineState = (examineState: any) => {
        switch (examineState) {
            case 'Complete':
                return <IconFont type="iconExamine_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconExamine_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconExamine_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconExamine_Question"></IconFont>
            case 'Answer':
                return <IconFont type="iconExamine_Answer"></IconFont>
            default:
                break;
        }
    }

    //处理from中Freeze状态
    const switchFormFreezeState = (freezeState: any) => {
        switch (freezeState) {
            case 'Complete':
                return <IconFont type="iconFreeze_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconFreeze_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconFreeze_Wait"></IconFont>
            default:
                break;
        }
    }
    //处理from中Autograph状态
    const switchFormAutographState = (autographState: any) => {
        switch (autographState) {
            case 'Complete':
                return <IconFont type="iconAutograph_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconAutograph_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconAutograph_Wait"></IconFont>
            default:
                break;
        }
    }


    //处理from中Lock状态
    const switchFormLockState = (lockState: any) => {
        switch (lockState) {
            case 'Complete':
                return <IconFont type="iconLock_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconLock_Running"></IconFont>
            case 'Wait':
                return <IconFont type="iconLock_Wait"></IconFont>
            default:
                break;
        }
    }

    //处理ocr录入状态
    const switchFormOcrState = (ocrState: any) => {
        switch (ocrState) {
            case 'Complete':
                return <IconFont type="iconOcr_Complete"></IconFont>
                break;
            case 'Wait':
                return <IconFont type="iconOcr_Wait"></IconFont>
                break;
            case 'Running':
                return <IconFont type="iconOcr_Running"></IconFont>
                break;
            default:
                break;
        }
    }

    //拒绝排除
    const onReject = () => {
        setLoading(true);
        let params = {
            id: subjectsData.code
        }
        api.subjectPass(params).then(res => {
            if (res.code == '0') {
                Toast.success(`拒绝排除`, 1);
                props.history.replace('/home')
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('拒绝排除失败！', 1)
                }
            }
            setLoading(false);
        })
    }

    //通过入组
    const onThrough = () => {
        setLoading(true);
        let params = {
            id: subjectsData.code
        }
        api.subjectJoin(params).then(res => {
            if (res.code == '0') {
                Toast.success(`通过入组`, 1);
                props.history.replace(`/subjectsDetail/${res.data}?projectType=${utils.getUrlParams().projectType || ''}`)
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('通过入组失败！', 1)
                }
            }
            setLoading(false);
        })
    }

    //查看表单详情
    const clickForm = (item: any, formItem: any) => {
        return () => {
            // 锁定状态
            if (formItem.lockState && formItem.lockState == 'Complete') {
                sessionStorage.setItem('formLockState', formItem.lockState)
            }

            let filterArr = [];
            for (let i of item.forms) {
                filterArr.push({
                    title: i.name,
                    id: i.id,
                    code: i.code,
                    inputState: i.inputState
                })
            }

            let forms = {
                activeId: formItem.id,
                forms: filterArr,
            };

            localStorage.setItem('localStorage_forms', JSON.stringify(forms));
            sessionStorage.removeItem('currentState');

            // if (item.type === 'SingleForm') {
            //     setShowVisitForm(true);
            // } else {
            //     props.history.push({ pathname: '/visitForm' });
            // }

            // 单表单模式
            if (item.type == 'SingleForm') {
                // crf表单
                if (formItem.type == 'CRF') {
                    registerCrfMicro(formItem)
                } else {
                    sessionStorage.removeItem('crfParams')
                }
                setShowVisitForm(true);
            } else {
                // crf表单
                if (formItem.type == 'CRF') {
                    registerCrfMicro(formItem)
                } else {
                    sessionStorage.removeItem('crfParams')
                }
                props.history.push({ pathname: '/visitForm' });
            }
        }
    }

    // crf表单集成
    const registerCrfMicro = (formItem: any) => {
        const caseCode = sessionStorage.getItem('caseCode');
        const eventCode = sessionStorage.getItem('eventCode');

        let crfParams = {
            crfCode: formItem.code,
            crfVersion: formItem.version,
            recordCode: formItem.id,
            tenantCode: '',

            caseCode,
            eventCode,
            projectCode: '',
            userCode: '',
            headers: {},
            
        }

        const token = sessionStorage.getItem('token');
        const _itemData = sessionStorage.getItem('toPhotoEditItem');
        if (token) {
            let t = JSON.parse(token);
            crfParams.tenantCode = t.tenantCode
            crfParams.userCode = t.userCode
        }
        if (_itemData) {
            let _i = JSON.parse(_itemData);
            crfParams.projectCode = _i.projectCode
        }

        sessionStorage.setItem('crfParams', JSON.stringify(crfParams))
    }

    //添加表单
    const addFormBtn = (item: any) => {
        return () => {

        }
    }

    //当点击实际访视时间修改按钮
    const onClickVisitDateModify = (form: any) => {
        return () => {
            if (form.visitDate) {
                setVisitDate(new Date(form.visitDate))
            }
            else {
                setVisitDate(new Date())
            }
            setVisitDateModalShow(true);
        }
    }

    //当实际访视时间修改时
    const onVisitDateModify = (form: any) => {
        let params = {
            visitDate: visitDate,
            visitId: form.id
        }
        api.modifyVisitDate(params).then(res => {
            if (res.code == '0') {
                Toast.success('修改成功！', 1)
                setVisitDateModalShow(false);
                //更新数据
                getData();
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('修改失败！', 1)
                }
            }
        })
    }

    //当点击添加备注按钮
    const onClickAddRemark = () => {
        let params = {
            type: 'SubjectRemarkType'
        }
        api.getRemarkType(params).then(res => {
            if (res.code == '0') {
                if (res.data && res.data.length > 0) {
                    let filterArr = [];
                    for (let item of res.data) {
                        filterArr.push(
                            {
                                label: item.name,
                                value: item.code
                            }
                        )
                    }
                    setRemarkTypeList(filterArr);
                }
            }
        })

        let isWarningList = [
            {
                label: '警示',
                value: 1,
            },
            {
                label: '非警示',
                value: 0,
            }
        ]
        setIsWarningList(isWarningList);
        setRemarkModalShow(true)
    }

    //当提交备注
    const onRemark = () => {
        if (remarkIsWarning && remarkValue && remarkValue.trim() && currentRemarkType && currentRemarkType.length > 0) {
            let params = {
                subjectCode: subjectsData.code,
                isWarning: remarkIsWarning[0],
                remark: remarkValue,
                remarkType: currentRemarkType[0]
            }
            api.addRemark(params).then(res => {
                if (res.code == '0') {
                    getData();
                    Toast.success('添加成功！', 1)
                    setCurrentRemarkType(null);
                    setRemarkValue(null);
                    setRemarkIsWarning(null);
                    setRemarkModalShow(false);
                }
                else {
                    if (res.message) {
                        Toast.success(res.message, 1);
                    }
                    else {
                        Toast.success('添加失败！', 1);
                    }
                }
            })
        }
        else {
            Toast.fail('请填写完整后再试！', 1)
        }
    }

    const reloadSubjectData = async()=> {
        const { code, data } = await api.getSubjectdDetail({ id: props.match.params.id })
        if(code == "0") {
            setSubjectsData(data)
        }
    }

    return (
        <div className={styles.checkSubject_content}>
            {
                projectType !== 'VIDEOSOLICIT' &&
                <div className={styles.header_content}>
                    <div className={styles.portrait}>
                        <img src={defaultAvatar} alt="defaultAvatar" />
                    </div>
                    <div className={styles.info}>
                        <div className={styles.info_top}>
                            <span className={styles.projectId}>
                                {subjectsData.code}
                            </span>
                            <span className={styles.userName}>
                                {subjectsData.createUser}
                            </span>
                            {/*<span className={styles.addBtn} onClick={onClickAddRemark}>*/}
                            {/*    <IconFont type="iconAdd"></IconFont>添加备注*/}
                            {/*</span>*/}
                        </div>
                        {/* 项目名称 */}
                        <div className={styles.info_projectName}>
                            {subjectsData.projectName}
                        </div>
                         {/* subjectsData.code 加载显示优化*/}
                        {
                            subjectsData.code && subjectsData.editModel === 1 && (
                                <SubjectBind editModel={ subjectsData.editModel }  mobile={subjectsData.mobile} subjectName={subjectsData.subjectName} refresh={()=>{}} resumeVisitId={""}  isShowBind={false}/> 
                            ) 
                        }
                        {/* 状态 */}
                        <div className={styles.info_state}>
                            {subjectsData.state == 'Init' ? <React.Fragment>
                                <span style={{ color: '#5EBCBC' }}><IconFont type="iconWait"></IconFont>待入组</span>
                            </React.Fragment> : null}
                            {subjectsData.state == 'Active' ? <React.Fragment>
                                <span style={{ color: '#5EBCBC' }}><IconFont type="iconRunning"></IconFont>访视中</span>
                            </React.Fragment> : null}

                            {/* 君实签署协议 */}
                            { 
                                subjectsData.editModel === 1  &&  (['EDC_CRC', 'DCT_CRC'].includes(mToken.roleCode) && projectRoleCode !== 'ReadOnly'  ) && subjectsData.informed !== 2 && (
                                    <SignAgreementLink onReload={reloadSubjectData} subjectsData={subjectsData}/>
                                )
                            }
                        </div>
                        {/* 备注 */}
                        <div className={styles.note_content}>
                            <div className={styles.remarks}>
                                {
                                    subjectsData.remarks && subjectsData.remarks.map((item: any, index: any) => {
                                        return (
                                            <span key={index} style={{ color: item.isWarning ? '#EF8767' : '#9A9FAB', border: item.isWarning ? '1px solid #EF8767' : '1px solid #9A9FAB' }}>{item.remark}</span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                formData && formData.length > 0 && formData.map((item: any, index: any) => {
                    return (
                        <React.Fragment key={index}>
                            <div className={styles.visit_Detail}>
                                <div className={styles.visit_top}>
                                    <div className={styles.visit_name}>{item.name}</div>
                                    {/* <div className={styles.addVisit}>
                                        <IconFont type="iconAddVisit"></IconFont>添加访视
                                    </div> */}
                                </div>
                                {
                                    //  计划访视和临时访视（无状态）时才显示预约模块
                                    (formData && formData.length == 1 && (formData[0].type === 'PlanVisit' || formData[0].type === 'StatelessVisit')) ? <div className={styles.detail}>
                                        <div className={styles.detail_content}>
                                            <div className={styles.visit_time}>
                                                <div className={styles.visit_time_title}>
                                                    <span>计划访视时间</span>
                                                </div>
                                                <div className={styles.time}>
                                                    {
                                                        item.planDate ? item.planDate : '暂无'
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.visit_time} onClick={onClickVisitDateModify(item)}>
                                                <div className={styles.visit_time_title}>
                                                    <span>实际访视时间</span>
                                                </div>
                                                <div className={styles.time}>
                                                    {
                                                        item.visitDate ? item.visitDate : '设置'
                                                    }
                                                    <IconFont type="iconModify"></IconFont>
                                                </div>
                                            </div>
                                            {/* 设置实际访视时间弹框 */}
                                            <Modal
                                                visible={visitDateModalShow}
                                                transparent
                                                maskClosable={false}
                                                onClose={() => { setVisitDateModalShow(false) }}
                                                title="设置实际访视时间"
                                                footer={[{ text: '取消', onPress: () => { setVisitDateModalShow(false); } }, { text: '确认', onPress: () => { onVisitDateModify(item) } }]}
                                            >
                                                <DatePickerView
                                                    mode="date"
                                                    value={visitDate}
                                                    onChange={(value) => { setVisitDate(value) }}
                                                />
                                            </Modal>
                                        </div>
                                        <div className={styles.visit_label}>
                                            <div className={styles.label}>
                                                访视日程
                                            </div>
                                        </div>
                                    </div> : null
                                }
                            </div>
                            <div className={styles.forms_content}>
                                {
                                    item.forms && item.forms.map((formItem: any, index: any) => {
                                        return (
                                            <div key={index} className={styles.formItem} onClick={clickForm(item, formItem)}>
                                                <div className={styles.borderLeft}>
                                                    {
                                                        switchFormBorder(formItem)
                                                    }
                                                </div>
                                                <div className={styles.form_name}>
                                                    {formItem.name}
                                                </div>
                                                <div className={styles.state}>
                                                    {
                                                        switchFormOcrState(formItem.ocrState)
                                                    }
                                                    {
                                                        switchFormInputState(formItem.inputState)
                                                    }
                                                    {
                                                        switchFormCheckState(formItem.checkState)
                                                    }
                                                    {
                                                        switchFormQuestionState(formItem.questionState)
                                                    }
                                                    {
                                                        switchFormExamineState(formItem.examineState)
                                                    }
                                                    {
                                                        switchFormFreezeState(formItem.freezeState)
                                                    }
                                                    {
                                                        switchFormAutographState(formItem.autographState)
                                                    }
                                                    {
                                                        switchFormLockState(formItem.lockState)
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                {/* <div className={styles.addFrom} onClick={addFormBtn(item)}>
                                    <IconFont type="iconAdd"></IconFont>添加表单
                                </div> */}
                            </div>
                        </React.Fragment>
                    )
                })
            }
            <div className={styles.action_content} style={{ display: (projectRoleCode == 'ReadOnly' || mToken.roleCode == 'EDC_READ') ? 'none' : '' }}>
                <div className={styles.reject} onClick={onReject}>
                    <IconFont type="iconReject"></IconFont>拒绝排除
                </div>
                <div className={styles.through} onClick={onThrough}>
                    <IconFont type="iconThrough"></IconFont>通过入组
                </div>
            </div>

            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />

            <Modal visible={remarkModalShow} popup={true} animationType={'slide-up'} onClose={() => { setRemarkModalShow(false) }}>
                <div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid rgb(146, 143, 143)', color: 'black' }}>
                        <div style={{ width: 'calc(100% - 1rem)', textAlign: 'center', paddingLeft: '1rem', fontSize: '0.426667rem', lineHeight: '1.066667rem' }}>添加备注</div>
                        <img style={{ width: '0.48rem', height: '0.48rem', margin: '0.26rem' }} onClick={() => { setRemarkModalShow(false) }} src={close} alt="关闭弹框" />
                    </div>
                    <div style={{ marginTop: '0.3rem' }}>
                        <Picker data={remarkTypeList} value={currentRemarkType} cols={1} className="forss" onOk={(value) => { setCurrentRemarkType(value) }}>
                            <List.Item arrow="horizontal">备注类型</List.Item>
                        </Picker>
                    </div>
                    <div style={{ marginTop: '0.3rem' }}>
                        <InputItem
                            placeholder="请输入备注内容"
                            value={remarkValue}
                            onChange={(value) => { setRemarkValue(value) }}
                            style={{ textAlign: 'right', color: '#2A344D' }}
                        ><div>备注内容</div></InputItem>
                    </div>
                    <div style={{ marginTop: '0.3rem' }}>
                        <Picker data={isWarningList} value={remarkIsWarning} cols={1} className="forss" onOk={(value) => { setRemarkIsWarning(value) }}>
                            <List.Item arrow="horizontal">是否警示</List.Item>
                        </Picker>
                    </div>
                    <div style={{ margin: '2rem 0.8rem 2rem 0.8rem' }}>
                        <Button style={{ backgroundColor: '#6287EC', borderRadius: '0.8rem' }} type="primary" onClick={onRemark}>确定</Button>
                    </div>
                </div>
            </Modal>

            {
                showVisitForm &&
                <VisitForm inPrePage={true}  {...props}  />
            }


            {/* 操作按钮 */}
            <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                <img src={backBtn} alt="back" onClick={() => { props.history.go(-1) }} />
            </div>
        </div>
    )
}


export default CheckSubject;